import type { SourceChannel } from '../api/callsApi';

export const CHANNEL_OPTIONS: { value: SourceChannel; label: string }[] = [
  { value: 'google_ads', label: 'Google Ads' },
  { value: 'meta', label: 'Meta' },
  { value: 'mailer', label: 'Direct mail' },
  { value: 'landing_page', label: 'Landing page' },
  { value: 'gbp', label: 'Google Business Profile' },
  { value: 'print', label: 'Print / other' },
  { value: 'other', label: 'Other' },
];

export function channelLabel(channel: string): string {
  return CHANNEL_OPTIONS.find((c) => c.value === channel)?.label ?? channel;
}
